import AppBar from '@mui/material/AppBar'
import React from 'react'
import Grid from '@mui/material/Grid'
import { SettingsSubheader } from '../../shared/organism/SettingsSubheader'


export const UserReportsHeader = () => {
  const pathName = 'reports'

  return (
    <AppBar
      position={'relative'}
      color={'transparent'}
      elevation={0}
      sx={{
        maxWidth: 'xl',
        justifySelf: 'center',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
        mx: 'auto',
        px: 5,
        mt: '28px',
      }}>
      <Grid container rowSpacing={10}>
        <Grid item xs={12}>
          <SettingsSubheader pathName={pathName}/>
        </Grid>
      </Grid>
    </AppBar>
  )
}
